import { createSelector, Selector } from 'reselect'

import { CustomerState } from './customer.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetCustomer = Selector<RootState, CustomerState>
const getCustomer: GetCustomer = (state) => state.customer

export const selectCustomer = createSelector(getCustomer, (customer) => customer.data)

export const selectCustomerLoading = createSelector(getCustomer, (customer) => customer.loading)

export const selectCustomerError = createSelector(getCustomer, (customer) => customer.error)
